import { IMAGES } from "../constants/config";

export const candidatsContent = {
  meta: {
    title: "Crush Emploi — Candidatures vidéo et crush mutuel pour les jeunes",
    description:
      "L'app sociale de recrutement pour les 16–26 ans. Postule en vidéo, like les offres, crush mutuel — 100 % gratuit.",
  },
  variant: "candidat",
  alternateLink: {
    label: "Espace entreprise",
    to: "/entreprises",
  },
  hero: {
    title: "Décroche le job de tes rêves en postulant en vidéo",
    subtitle:
      "L'app sociale de recrutement pensée pour la Gen Z : like, postule en vidéo, obtiens un crush mutuel.",
    cta: "Rejoins la liste d'attente",
    image: IMAGES.heroes.candidat,
    imageAlt: "Illustration candidat Crush Emploi",
  },
  why: {
    title: "Le recrutement n'a pas suivi la Gen Z",
    stats: [
      {
        value: "21,1 %",
        label: "de chômage chez les 15–24 ans en France (T1 2026)",
        source: "Insee",
        sourceUrl: "https://www.insee.fr/fr/statistiques/8989990",
      },
      {
        value: "95 %",
        label: "des 16–24 ans utilisent les réseaux sociaux (2025)",
        source: "Insee",
        sourceUrl: "https://www.statistiques.com/internet/adolescents-et-internet",
      },
    ],
    paragraphs: [
      "Tu vis sur les réseaux sociaux, pas sur les jobboards classiques. Pourtant, le recrutement peine encore à parler ta langue.",
    ],
    itemsTitle: "Pourquoi Crush Emploi ?",
    items: [
      {
        icon: "videocam",
        title: "Candidature vidéo",
        description:
          "Montre ta personnalité et ta motivation en vidéo — bien plus humain qu'un CV papier.",
      },
      {
        icon: "heart",
        title: "Crush mutuel",
        description:
          "Like une offre, postule en vidéo. Si l'entreprise te like en retour, c'est le coup de cœur pro.",
      },
      {
        icon: "mobile",
        title: "App sociale",
        description:
          "Une expérience ludique inspirée des apps que tu utilises déjà, avec filtres par localisation, contrat et salaire.",
      },
    ],
  },
  howItWorks: {
    title: "Comment ça marche ?",
    image: IMAGES.sections.femmePhone,
    imageAlt: "Jeune femme utilisant Crush Emploi sur son téléphone",
    steps: [
      {
        title: "Crée ton compte",
        description: "Inscription rapide avec email ou Google, puis complète ton profil.",
      },
      {
        title: "Découvre les offres",
        description:
          "Parcours les annonces près de chez toi — CDI, CDD, stage, alternance, saisonnier — avec filtres contrat, salaire et localisation.",
      },
      {
        title: "Like et postule en vidéo",
        description:
          "Like une offre qui te plaît, enregistre ta candidature vidéo depuis ton téléphone.",
      },
      {
        title: "Crush = mise en relation",
        description:
          "Match mutuel : vos coordonnées sont échangées pour un premier contact direct.",
      },
    ],
  },
  faq: {
    title: "Questions fréquentes",
    items: [
      {
        question: "C'est pour qui ?",
        answer:
          "Crush Emploi s'adresse aux jeunes de 16 à 26 ans en recherche d'emploi, de stage, d'alternance ou de job saisonnier.",
      },
      {
        question: "La candidature vidéo est-elle obligatoire ?",
        answer:
          "Oui, pour postuler à une offre tu enregistres une vidéo depuis ton téléphone. C'est rapide, authentique et bien plus humain qu'un simple CV papier.",
      },
      {
        question: "Comment fonctionne le crush ?",
        answer:
          "Tu postules en vidéo aux offres qui te plaisent. Si l'entreprise like ta candidature en retour, c'est un crush : tes coordonnées sont échangées avec l'entreprise pour qu'elle puisse te recontacter (avec ton consentement).",
      },
      {
        question: "Puis-je refaire ma vidéo ?",
        answer:
          "Tu peux t'entraîner avant d'envoyer. Une fois la candidature envoyée, la vidéo ne peut plus être modifiée pour garantir l'authenticité.",
      },
      {
        question: "Combien ça coûte ?",
        answer: "Crush Emploi est entièrement gratuit pour les candidats.",
      },
      {
        question: "Où télécharger l'app ?",
        answer:
          "L'app sera bientôt disponible sur l'App Store et Google Play. En attendant, inscris-toi à la liste d'attente pour être prévenu dès le lancement.",
      },
      {
        question: "Les offres sont-elles en vidéo ?",
        answer:
          "Non, pour l'instant : les offres sont textuelles et seules tes candidatures sont en vidéo. Des offres en vidéo sont envisagées en V2.",
      },
    ],
  },
  ctaBanner: {
    title: "Sois parmi les premiers à découvrir Crush Emploi",
    subtitle:
      "Inscris-toi à la liste d'attente et sois prévenu dès le lancement de l'app.",
  },
};
